/**
 * Le Righe — "Completa il look" e "Vuoi aggiungere anche...?" (snippets/righe-abbinamenti.liquid).
 *
 * Il pulsante "Aggiungi" mette il capo nel carrello senza cambiare pagina e avvisa
 * il tema con lo stesso evento usato da Horizon (CartLinesUpdateEvent): così il
 * carrello laterale si apre e il numerino del carrello si aggiorna come con il
 * normale "Aggiungi al carrello".
 */
import { CartLinesUpdateEvent } from '@shopify/events';

async function leggiCarrello() {
  const res = await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' } });
  return res.json();
}

document.addEventListener('submit', async (event) => {
  const form = event.target instanceof HTMLFormElement && event.target.closest('form[data-righe-abbina]');
  if (!form) return;
  event.preventDefault();

  const id = form.elements.namedItem('id')?.value;
  const button = form.querySelector('button[type="submit"]');
  const errore = form.parentElement?.querySelector('.righe-abbina__errore');
  if (!id || !button) return;

  button.disabled = true;
  if (errore) errore.hidden = true;

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: id, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    });
    const risposta = await res.json();
    const cart = await leggiCarrello();
    const fallito = Boolean(risposta.status);

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'righe-abbinamenti', itemCount: 1, didError: fallito },
    });

    if (fallito) {
      if (errore) {
        errore.textContent = risposta.description || risposta.message || button.dataset.testoErrore || '';
        errore.hidden = false;
      }
      button.disabled = false;
      return;
    }

    const testo = button.textContent;
    button.textContent = button.dataset.testoAggiunto || testo;
    setTimeout(() => {
      button.textContent = testo;
      button.disabled = false;
    }, 2000);
  } catch (error) {
    deferred.reject(error);
    if (errore) {
      errore.textContent = button.dataset.testoErroreRete || '';
      errore.hidden = false;
    }
    button.disabled = false;
  }
});
